module.exports = __webpack_public_path__ + "img/home_my_value_03.b097e629.png";